// Language type
export type Language = 'tr' | 'en' | 'es' | 'ru' | 'de' | 'fr' | 'it' | 'pt' | 'nl' | 'pl' | 'ar' | 'zh' | 'ja' | 'ko' | 'he' | 'fa' | 'hi' | 'id' | 'th' | 'vi' | 'uk' | 'cs' | 'sv' | 'no' | 'da' | 'bg' | 'hr' | 'ro' | 'sr' | 'sk' | 'sl' | 'et' | 'lv' | 'lt' | 'fi' | 'hu' | 'el' | 'ms' | 'tl' | 'bn' | 'ta' | 'te' | 'mr' | 'ur' | 'sw' | 'am' | 'km' | 'my' | 'lo' | 'ne' | 'si' | 'ka' | 'hy' | 'az' | 'kk' | 'uz' | 'mn' | 'af' | 'zu' | 'is' | 'mt' | 'sq' | 'mk' | 'bs' | 'cy' | 'eu' | 'gl' | 'ca' | 'lb' | 'ga' | 'gu' | 'kn' | 'ml' | 'pa' | 'or' | 'as' | 'sd' | 'ps' | 'ku' | 'ckb' | 'yi' | 'ug' | 'tk' | 'ky' | 'tg' | 'tt' | 'ba' | 'be' | 'fo' | 'fy' | 'gd' | 'haw' | 'sm' | 'ceb' | 'hmn' | 'mg' | 'ny' | 'sn' | 'st' | 'so' | 'ha' | 'ig' | 'yo' | 'xh' | 'jv' | 'su' | 'eo' | 'la' | 'co' | 'ht' | 'mi' | 'cy-GB' | 'ln' | 'rw' | 'ky-KG';

// Import all translations statically (Updated 2025)
import { tr } from './tr';
import { en } from './en';
import { es } from './es';
import { ru } from './ru';
import { de } from './de';
import { fr } from './fr';
import { it } from './it';
import { pt } from './pt';
import { nl } from './nl';
import { pl } from './pl';
import { ar } from './ar';
import { zh } from './zh';
import { ja } from './ja';
import { ko } from './ko';
import { he } from './he';
import { fa } from './fa';
import { hi } from './hi';
import { id } from './id';
import { th } from './th';
import { vi } from './vi';
import { uk } from './uk';
import { cs } from './cs';
import { sv } from './sv';
import { no } from './no';
import { da } from './da';
import { bg } from './bg';
import { hr } from './hr';
import { ro } from './ro';
import { sr } from './sr';
import { sk } from './sk';
import { sl } from './sl';
import { et } from './et';
import { lv } from './lv';
import { lt } from './lt';
import { fi } from './fi';
import { hu } from './hu';
import { el } from './el';
import { ms } from './ms';
import { tl } from './tl';
import { bn } from './bn';
import { ta } from './ta';
import { te } from './te';
import { mr } from './mr';
import { ur } from './ur';
import { sw } from './sw';
import { am } from './am';
import { km } from './km';
import { my } from './my';
import { lo } from './lo';
import { ne } from './ne';
import { si } from './si';
import { ka } from './ka';
import { hy } from './hy';
import { az } from './az';
import { kk } from './kk';
import { uz } from './uz';
import { mn } from './mn';
import { af } from './af';
import { zu } from './zu';
import { is } from './is';
import { mt } from './mt';
import { sq } from './sq';
import { mk } from './mk';
import { bs } from './bs';
import { cy } from './cy';
import { eu } from './eu';
import { gl } from './gl';
import { ca } from './ca';
import { lb } from './lb';
import { ga } from './ga';
import { gu } from './gu';
import { kn } from './kn';
import { ml } from './ml';
import { pa } from './pa';
import { or } from './or';
import { as } from './as';
import { sd } from './sd';
import { ps } from './ps';
import { ku } from './ku';
import { ckb } from './ckb';
import { yi } from './yi';
import { ug } from './ug';
import { tk } from './tk';
import { ky } from './ky';
import { tg } from './tg';
import { tt } from './tt';
import { ba } from './ba';
import { be } from './be';
import { fo } from './fo';
import { fy } from './fy';
import { gd } from './gd';
import { haw } from './haw';
import { sm } from './sm';
import { ceb } from './ceb';
import { hmn } from './hmn';
import { mg } from './mg';
import { ny } from './ny';
import { sn } from './sn';
import { st } from './st';
import { so } from './so';
import { ha } from './ha';
import { ig } from './ig';
import { yo } from './yo';
import { xh } from './xh';
import { jv } from './jv';
import { su } from './su';
import { eo } from './eo';
import { la } from './la';
import { co } from './co';
import { ht } from './ht';
import { mi } from './mi';
import { cyGB } from './cy-GB';
import { ln } from './ln';
import { rw } from './rw';
import { kyKG } from './ky-KG';

// Translation map
const translationMap: Record<Language, Record<string, string>> = {
  tr,
  en,
  es,
  ru,
  de,
  fr,
  it,
  pt,
  nl,
  pl,
  ar,
  zh,
  ja,
  ko,
  he,
  fa,
  hi,
  id,
  th,
  vi,
  uk,
  cs,
  sv,
  no,
  da,
  bg,
  hr,
  ro,
  sr,
  sk,
  sl,
  et,
  lv,
  lt,
  fi,
  hu,
  el,
  ms,
  tl,
  bn,
  ta,
  te,
  mr,
  ur,
  sw,
  am,
  km,
  my,
  lo,
  ne,
  si,
  ka,
  hy,
  az,
  kk,
  uz,
  mn,
  af,
  zu,
  is,
  mt,
  sq,
  mk,
  bs,
  cy,
  eu,
  gl,
  ca,
  lb,
  ga,
  gu,
  kn,
  ml,
  pa,
  or,
  as,
  sd,
  ps,
  ku,
  ckb,
  yi,
  ug,
  tk,
  ky,
  tg,
  tt,
  ba,
  be,
  fo,
  fy,
  gd,
  haw,
  sm,
  ceb,
  hmn,
  mg,
  ny,
  sn,
  st,
  so,
  ha,
  ig,
  yo,
  xh,
  jv,
  su,
  eo,
  la,
  co,
  ht,
  mi,
  'cy-GB': cyGB,
  ln,
  rw,
  'ky-KG': kyKG,
};

// Dynamic translation loader (now uses static imports)
export async function loadTranslations(language: Language): Promise<Record<string, string>> {
  try {
    const langMap = translationMap[language];
    if (langMap) {
      // Merge with English as fallback for missing keys
      return { ...translationMap.en, ...langMap };
    }
    // Fallback to English
    return translationMap.en;
  } catch (error) {
    console.error(`Failed to load translations for language: ${language}`, error);
    // Fallback to English
    return translationMap.en;
  }
}
